export const RATE_DEFAULT = 3;
export const RATE_MAX = 7;
export const RATE_MIN = 1;
export const GOAL_CAPITAL_MIN = 0;
export const GOAL_CAPITAL_MAX = 10 ** 7;
export const INCOME_ID = 'targetIncome';
export const INCOME_RATE_ID = 'incomeRate';
export const CAPITAL_ID = 'targetCapital';
export const CAPITAL_RATE_ID = 'capitalRate';
export const OWNER_PRIMARY = 'primaryContact';
export const OWNER_SECONDARY = 'secondaryContact';
export const OWNER_JOINT = 'jointLives';
export const OWNER_FAMILY = 'accountOwned';
export const OWNER_TRUST = 'accountTrustOwned';
export const OWNER_FAMILY_LABEL = 'Whole Family';
export const MAX_MOMENT_YEAR = 2099;
export const PURPOSE_RETIREMENT = 'retirement';
export const OBJECTIVE_INCOME = 'income';
export const OBJECTIVE_CAPITAL = 'capital';
export const OBJECTIVE_ESTATE = 'estatePlanning';
export const TARGET_AGE_MIN = 0;
export const TARGET_AGE_MAX = 100;
export const PURPOSE_OTHER = 'other';
